/**
 * @description Utilitário para comunicação entre WebView e app nativo
 * @module webViewBridge
 * @since Março 2024
 */

interface WebViewMessage {
  type: string;
  payload?: any;
}

/**
 * Envia mensagem para o app nativo via WebView
 * @param message Mensagem a ser enviada
 */
export const sendWebViewMessage = (message: WebViewMessage): void => {
  try {
    if (window.ReactNativeWebView) {
      // Envia apenas o type como string para manter compatibilidade com iOS
      window.ReactNativeWebView.postMessage(message.type);
    }
  } catch (error) {
    console.error('Erro ao enviar mensagem para WebView:', error);
  }
};

/**
 * Tipos de mensagens suportadas
 */
export const MessageTypes = {
  LOGOUT: 'Logout',
  LOGIN_FAILED: 'Login Failed',
  // Adicione outros tipos de mensagem conforme necessário
} as const;
